<template>
  <div class="mb-4 sidebar">
    <div class="component">
      <div class="bo_categories-header d-flex align-items-center flex-wrap">
        <span class="element-title">Kategorier</span>
        <span v-if="!isEmployee" class="ms-auto text-nowrap">
          <!-- Was a bare 23px icon to the left of the title, which nobody read as a control. A label
               and a button shape say what it is; the glyph stays so it is still recognisable. -->
          <button type="button" class="bo_btn_secondary bo_btn_compact me-2" @click="goToSortCategoriesPage">
            <img src="@/assets/images/sort_order.png" width="18" class="bo_btn_icon" alt="" />Rekkefølge
          </button>
          <button type="button" class="bo_btn" @click="goToAddCategoryPage"> + Legg til kategori </button>
        </span>
      </div>
      <div class="content">
        <ul class="bo_categoriesList">
          <li v-for="category in categories" :key="category.id" class="category-row" :class="{ bo_active: category.id === activeCategoryId }">
            <a v-if="!isEmployee" class="remove-category-btn bo_remove-action"
               @click="removeCategory(category)">
              <img src="@/assets/images/remove.png" width="21" title="Slett kategori"/>
            </a>
            <span @click="goToCategoryDiv(category.id)" class="category-name">{{ category.name }}
              <span v-if="itemCounts[category.id] !== undefined" class="bo_count">({{ itemCounts[category.id] }})</span>
            </span>
            <a v-if="!isEmployee" class="edit-category-btn icon-btn"
               @click="editCategory(category.id)">
              <img src="@/assets/images/edit.png" width="21" title="Rediger kategori"/>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <ConfirmDialogue ref="confirmDialogue"></ConfirmDialogue>
</template>

<script>
import ConfirmDialogue from '@/components/other/ConfirmDialogue.vue'
import ProductService from "@/services/product/ProductService";
import UserUtil from "@/util/UserUtil";

export default {
  components: {ConfirmDialogue},
  props: {
    categories: Array,
    itemCounts: { type: Object, default: () => ({}) }, //Number of items per categoryId
    activeCategoryId: { type: String, default: '' } //Scroll-spy: category currently in view in the product column
  },
  emits: ['openPanel', 'refresh'],
  computed: {
    isEmployee(){
      return UserUtil.isEmployee();
    }
  },
  methods: {
      goToSortCategoriesPage(){
        this.$emit('openPanel', 'categoriesSort', {});
      },
      goToAddCategoryPage (){
        this.$emit('openPanel', 'categoryCreate', {});
      },
      async removeCategory(category){
        const ok = await this.$refs.confirmDialogue.show({
          title: 'Slett kategorien "' + category.name + '"',
          message: 'Vil du slette kategorien "' + category.name + '"' + ' og dens tilhørende produkter?',
          okButton: 'Slett',
          cancelButton: 'Avbryt'
        })
        if(ok) {
          ProductService.deleteCategory(category).then(
              (response) => {
                if(response.data != null){
                  this.$emit('refresh');
                }else {
                  console.log("Deleting category failed");
                }
              },
              (error) => {
                console.log(error);
              }
          );
        } else {
          //Cancel, do nothing
        }
      },
      goToCategoryDiv (categoryId){
          var categoryElementId = 'cat_' + categoryId;
          var element = document.getElementById(categoryElementId);
          element.scrollIntoView();
          /*
          var marginTop = 86;
          var scrolledY = window.scrollY;
          if(scrolledY){
            window.scroll(0, scrolledY - marginTop);
          }*/
      },
      editCategory(categoryId){
        this.$emit('openPanel', 'categoryEdit', { categoryId: categoryId });
      }
  }
}
</script>

<style scoped>
  /**
   * lg: 992px breakpoint or larger
   */
  @media screen and (min-width: 992px) {
    .bo_categories-header{
      padding-right: 5px;
    }

    .sidebar {
      position: sticky;
      top: var(--bo-nav-offset, 0px);   /* clears the pinned navbar */
    }
    .component {
      display: grid;
      grid-template-rows: auto 1fr auto;
    }
    .component .content {
      overflow-y: auto;
    }
    .sidebar .component {
      max-height: calc(100vh - 5px);
    }
  }
</style>
